"use strict";

var _regeneratorRuntime = require("/opt/build/repo/site/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/site/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var Axios = require("axios"),
  axiosRetry = require("axios-retry");
function _interopDefaultLegacy(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}
var Axios__default = _interopDefaultLegacy(Axios),
  axiosRetry__default = _interopDefaultLegacy(axiosRetry);
axiosRetry__default.default(Axios__default.default, {
  retries: 3,
  retryDelay: axiosRetry__default.default.exponentialDelay
});
var jsonpack = require("jsonpack"),
  GATSBY_WP_BASEURL = "https://cms.vibemap.com",
  REST_PATH = "/wp-json/wp/v2/",
  helpers = require("./helpers.js"),
  cities = helpers.cities,
  postCategories = require("../dist/postCategories");
var vibeTaxonomy = [],
  activityCategories = [];
try {
  var b = require("../dist/vibesFromCMSTaxonomy.zip.json");
  vibeTaxonomy = jsonpack.unpack(b);
} catch (e) {
  console.log("Error with packed vibes ", e);
}
try {
  var d = require("../dist/activityCategories.zip.json");
  activityCategories = jsonpack.unpack(d);
} catch (e) {
  console.log("Error with packed activityCategories ", e);
}
var defaultFilters = {
    categories: [],
    cities: [],
    vibesets: [],
    vibes: []
  },
  getTaxonomyIds = function getTaxonomyIds(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["chill"];
    switch (e) {
      case "category":
        return t.map(function (e) {
          var t = helpers.filterList(activityCategories, e, "slug");
          return 0 < t.length ? t.map(function (e) {
            return e.id;
          }) : [];
        });
      case "vibe":
        return t.map(function (e) {
          var t = helpers.filterList(vibeTaxonomy, e, "slug");
          return 0 < t.length ? t.map(function (e) {
            return e.id;
          }) : [];
        });
      case "cities":
        return t.map(function (e) {
          var t = helpers.filterList(helpers.cities, e, "slug");
          e = t.map(function (e) {
            return e && e.id_wordpress ? e.id_wordpress : e.id;
          });
          return 0 < t.length ? e : [];
        });
    }
    return [];
  },
  fetchBadges = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var e;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e = GATSBY_WP_BASEURL + REST_PATH + "badges";
            _context.next = 3;
            return Axios__default.default.get(e).catch(function (e) {
              return console.error(e);
            });
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchBadges() {
      return _ref.apply(this, arguments);
    };
  }(),
  fetchCities = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var e,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 50;
            e = "?_fields=id, link, name, radius, slug, title, acf, type\n      &per_page=" + e, e = GATSBY_WP_BASEURL + REST_PATH + "city" + e;
            _context2.next = 4;
            return Axios__default.default.get(e).catch(function (e) {
              return console.error(e);
            });
          case 4:
            return _context2.abrupt("return", _context2.sent);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function fetchCities() {
      return _ref2.apply(this, arguments);
    };
  }(),
  fetchNeighborhoods = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var s,
        e,
        i,
        t,
        a,
        r,
        o,
        c,
        _args4 = arguments;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            s = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : defaultFilters;
            e = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 1;
            i = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 10;
            t = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var e,
                  t,
                  a,
                  r,
                  o,
                  _args3 = arguments;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      e = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 1;
                      t = ["id", "slug", "type", "link", "title", "categories", "vibe", "acf", "featured_media", "featured_media_src_url"];
                      a = "?_fields=" + t.join(","), r = Math.random(), a = GATSBY_WP_BASEURL + "/wp-json/wp/v2/neighborhoods".concat(a, "&refresh=") + r;
                      _context3.next = 5;
                      return Axios__default.default.get(a, {
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json",
                          Cookie: "PHPSESSID=fc445d3668b82ce450818bff8f864d1d"
                        },
                        maxBodyLength: 1 / 0,
                        params: {
                          _embed: !1,
                          fields: t.join(","),
                          per_page: i,
                          page: 1 <= e ? e : 1,
                          categories: s.category,
                          vibesets: s.vibesets.toString()
                        }
                      }).catch(function (e) {
                        console.error(e);
                      });
                    case 5:
                      o = _context3.sent;
                      return _context3.abrupt("return", (o.numPages = parseInt(o.headers["x-wp-totalpages"]), o.data));
                    case 7:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function t() {
                return _ref4.apply(this, arguments);
              };
            }();
            _context4.next = 6;
            return t(e);
          case 6:
            a = _context4.sent;
            r = !0;
            c = e;
            console.log("Has more?  ", a.length, c * i);
          case 10:
            if (!r) {
              _context4.next = 21;
              break;
            }
            if (!(a.length >= c * i)) {
              _context4.next = 18;
              break;
            }
            _context4.next = 14;
            return t(c += 1).catch(function (e) {
              return console.error(e);
            });
          case 14:
            o = _context4.sent;
            a = a.concat(o);
            _context4.next = 19;
            break;
          case 18:
            r = !1;
          case 19:
            _context4.next = 10;
            break;
          case 21:
            return _context4.abrupt("return", a);
          case 22:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function fetchNeighborhoods() {
      return _ref3.apply(this, arguments);
    };
  }(),
  fetchActivityCategories = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var e,
        t,
        a,
        r,
        o,
        s,
        i,
        c,
        n,
        _args6 = arguments;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            e = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : defaultFilters;
            t = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 1;
            a = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : 100;
            r = _args6.length > 3 ? _args6[3] : undefined;
            o = function o() {
              try {
                var _e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                var _t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
                return function () {
                  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t) {
                    var a, r, o;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          a = Axios__default.default.CancelToken.source();
                          r = "activity-category";
                          o = Math.random();
                          t = GATSBY_WP_BASEURL + "/wp-json/wp/v2/".concat(r, "?per_page=").concat(t, "&page=").concat(e, "&refresh=") + o;
                          console.log("Fetching ".concat(r, " from ") + t);
                          _context5.next = 7;
                          return Axios__default.default.get(t, {
                            cancelToken: a.token
                          }).catch(function (e) {
                            console.error(e);
                          });
                        case 7:
                          e = _context5.sent;
                          return _context5.abrupt("return", e.data);
                        case 9:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5);
                  }));
                  return function (_x, _x2) {
                    return _ref6.apply(this, arguments);
                  };
                }()(_e, _t);
              } catch (e) {
                return Promise.reject(e);
              }
            };
            _context6.next = 7;
            return o(t, a);
          case 7:
            s = _context6.sent;
            i = !0;
            n = t;
            console.log("Has more?  ", s.length, n * a);
          case 11:
            if (!i) {
              _context6.next = 22;
              break;
            }
            if (!(s.length >= n * a)) {
              _context6.next = 19;
              break;
            }
            _context6.next = 15;
            return o(n += 1).catch(function (e) {
              return console.error(e);
            });
          case 15:
            c = _context6.sent;
            s = s.concat(c);
            _context6.next = 20;
            break;
          case 19:
            i = !1;
          case 20:
            _context6.next = 11;
            break;
          case 22:
            return _context6.abrupt("return", (console.log("Got this many activities: ", s.length), s));
          case 23:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function fetchActivityCategories() {
      return _ref5.apply(this, arguments);
    };
  }(),
  fetchCategories = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var e,
        t,
        a,
        r,
        o,
        _args7 = arguments;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            e = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : defaultFilters;
            t = _args7.length > 1 ? _args7[1] : undefined;
            a = _args7.length > 2 ? _args7[2] : undefined;
            r = Axios__default.default.CancelToken.source();
            _context7.next = 6;
            return Axios__default.default.get(GATSBY_WP_BASEURL + "/wp-json/wp/v2/categories/", {
              cancelToken: r.token
            }).catch(function (e) {
              console.error(e);
            });
          case 6:
            o = _context7.sent;
            return _context7.abrupt("return", (o.numPages = parseInt(o.headers["x-wp-totalpages"]), o));
          case 8:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function fetchCategories() {
      return _ref7.apply(this, arguments);
    };
  }(),
  getCityInfo = function getCityInfo() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "San Francisco";
    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var e = null;
    a && (a = a.toString(), r = cities.filter(function (e) {
      return e.slug === a.toString();
    }), e = 0 < r.length ? r[0] : null);
    var r = cities.filter(function (e) {
      return e.name === t;
    });
    return e = 0 < r.length ? r[0] : null;
  },
  filterNeighborhoods = function filterNeighborhoods(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "San Francisco";
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var r;
    a && (a = a.toString(), r = cities.filter(function (e) {
      return e.slug === a.toString();
    }), t = 0 < r.length ? r[0].title.rendered : null);
    return t || a ? filter(e, function (e) {
      return e.city === t || e.title.includes(t);
    }) : e;
  },
  fetchVibeTaxonomy = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var e,
        t,
        r,
        o,
        a,
        s,
        i,
        c,
        n,
        _args9 = arguments;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            e = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : 1;
            t = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : 100;
            r = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : ["acf", "id", "link", "name", "slug", "description"];
            o = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : !0;
            a = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                var e,
                  t,
                  a,
                  _args8 = arguments;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      e = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : 1;
                      t = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : 100;
                      a = new Date();
                      t = "?_fields=".concat(r.join(","), "&per_page=").concat(t, "&page=") + e, e = GATSBY_WP_BASEURL + REST_PATH + "vibe" + t + (o ? "&" + a.toISOString() : "");
                      _context8.next = 6;
                      return Axios__default.default.get(e).catch(function (e) {
                        return console.error(e);
                      });
                    case 6:
                      return _context8.abrupt("return", _context8.sent.data);
                    case 7:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              }));
              return function a() {
                return _ref9.apply(this, arguments);
              };
            }();
            _context9.next = 7;
            return a(e, t);
          case 7:
            s = _context9.sent;
            i = !0;
            n = e;
          case 10:
            if (!i) {
              _context9.next = 21;
              break;
            }
            if (!(s.length >= n * t)) {
              _context9.next = 18;
              break;
            }
            _context9.next = 14;
            return a(n += 1).catch(function (e) {
              return console.error(e);
            });
          case 14:
            c = _context9.sent;
            s = s.concat(c);
            _context9.next = 19;
            break;
          case 18:
            i = !1;
          case 19:
            _context9.next = 10;
            break;
          case 21:
            return _context9.abrupt("return", s);
          case 22:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function fetchVibeTaxonomy() {
      return _ref8.apply(this, arguments);
    };
  }(),
  getGroups = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var _ref11,
        _ref11$city,
        t,
        _ref11$per_page,
        e,
        a,
        _args10 = arguments;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _ref11 = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {}, _ref11$city = _ref11.city, t = _ref11$city === void 0 ? null : _ref11$city, _ref11$per_page = _ref11.per_page, e = _ref11$per_page === void 0 ? 100 : _ref11$per_page;
            e = "?_fields=id,date,slug,title,acf&per_page=" + e, e = GATSBY_WP_BASEURL + REST_PATH + "group" + e;
            _context10.next = 4;
            return Axios__default.default.get(e).catch(function (e) {
              return console.error(e.response.statusText), {
                error: !0,
                data: {
                  data: []
                },
                message: e
              };
            });
          case 4:
            a = _context10.sent.data;
            e = a && "object" == typeof a ? a.filter(function (e) {
              return e.acf.map && t ? t == e.acf.map.city : (e.title = e.title.rendered, !0);
            }) : [];
            return _context10.abrupt("return", e ? {
              error: !1,
              data: e,
              message: "Got ".concat(e.length, " groups")
            } : {
              error: !0,
              data: [],
              message: "No data for groups"
            });
          case 7:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function getGroups() {
      return _ref10.apply(this, arguments);
    };
  }(),
  getPosts = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var e,
        t,
        a,
        r,
        o,
        s,
        i,
        c,
        n,
        l,
        _args11 = arguments;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            e = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : defaultFilters;
            t = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : !1;
            a = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : 20;
            r = _args11.length > 3 && _args11[3] !== undefined ? _args11[3] : ["id", "date", "slug", "status", "type", "link", "title", "content", "excerpt", "author", "categories", "vibe", "blocks", "acf", "featured_media", "featured_media_src_url"];
            o = _args11.length > 4 && _args11[4] !== undefined ? _args11[4] : !1;
            s = _args11.length > 5 && _args11[5] !== undefined ? _args11[5] : !1;
            o = o ? "&_embed" : "", r = "?_fields=" + r.join(",");
            i = new Date();
            r = "" + GATSBY_WP_BASEURL + REST_PATH + "posts" + r + o + (s ? "&" + i.toISOString() : "");
            c = {
              per_page: a,
              cities: getTaxonomyIds("cities", e.cities).toString(),
              sticky: !0
            };
            e.category && 0 < e.category.length && (c.category = getTaxonomyIds("category", e.category).toString()), e.vibes && 0 < e.vibes.length && (c.search = e.vibes.join(", "));
            _context11.next = 13;
            return Axios__default.default.get(r, {
              params: c
            }).catch(function (e) {
              console.error("Wordpress error", e);
            });
          case 13:
            n = _context11.sent;
            c.sticky = !1;
            console.log("getPosts endpoint", r, c);
            _context11.next = 18;
            return Axios__default.default.get(r, {
              params: c
            }).catch(function (e) {
              return console.error(e);
            });
          case 18:
            l = _context11.sent;
            o = l.data.filter(function (e) {
              return !0 !== e.acf.hide_post;
            }).map(function (t) {
              var e = postCategories.filter(function (e) {
                return e.id === t.categories[0];
              });
              return t.category = e ? e[0].name : "Guide", t;
            });
            return _context11.abrupt("return", !0 === t ? n : (l.data = l ? n.data.concat(o) : n, l));
          case 21:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function getPosts() {
      return _ref12.apply(this, arguments);
    };
  }(),
  getPost = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e) {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            Axios__default.default({
              url: "https://cms.vibemap.com/graphql",
              method: "post",
              data: {
                operationName: "PostDetails",
                query: "query PostDetails($id: String!) {\n        posts {\n          nodes {\n            id\n            slug\n          }\n        }\n      }\n      ",
                variables: {
                  id: e
                }
              }
            }).then(function (e) {
              console.log(e.data);
            });
          case 1:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function getPost(_x3) {
      return _ref13.apply(this, arguments);
    };
  }();
exports.fetchActivityCategories = fetchActivityCategories, exports.fetchBadges = fetchBadges, exports.fetchCategories = fetchCategories, exports.fetchCities = fetchCities, exports.fetchNeighborhoods = fetchNeighborhoods, exports.fetchVibeTaxonomy = fetchVibeTaxonomy, exports.filterNeighborhoods = filterNeighborhoods, exports.getCityInfo = getCityInfo, exports.getGroups = getGroups, exports.getPost = getPost, exports.getPosts = getPosts, exports.getTaxonomyIds = getTaxonomyIds;